import './index.css'

const Mobile = () => (
  <div className="mobile-container">
    <img
      src="https://files.techmahindra.com/static/img/Open-Mobile-Networks.jpg"
      alt="mbl"
      className="mbl-1"
    />
    <h1 className="mbl-heading">Mobile Services</h1>
    <h1 className="mbl-heading2">Change the way your business operates :</h1>
    <p className="mbl-para"> * Efficiencies across business processes</p>
    <p className="mbl-para">* Provide apps designed for key user communities</p>
    <p className="mbl-para">
      * Speed intelligent decision-making and response with mobile analytics
    </p>
    <p className="mbl-para">
      * Empower employees and lead to greater productivity
    </p>
    <p className="mbl-para">
      * Win, retain, and entice customers with engaging apps
    </p>
    <div className="container2">
      <h1 className="mobile-heading">
        Amrutha Systems Mobility Services include:
      </h1>
      <div className="last-container">
        <div className="mobile-image-container">
          <img
            src="https://uploads-ssl.webflow.com/6448bf6f0640203c982ca15f/6448bf6f0640203a2f2ca483_MOBILE%20APPLICATION%20DEVELOPMENT.webp"
            alt="mobile"
            className="picture"
          />
        </div>
        <div className="mobile-main-points">
          <h1 className="point">Mobile application development :</h1>
          <p className="paragraph-point">* Native, Hybrid, HTML5Apps</p>
          <p className="paragraph-point">* Wireframe and UI/UX Design</p>
          <p className="paragraph-point">* Responsive web design</p>
          <p className="paragraph-point">* API / Web services</p>
        </div>
      </div>
      <div className="last-container">
        <div className="mobile-main-points2">
          <h1 className="point">Enterprise mobility applications :</h1>
          <p className="paragraph-point">
            * Trends are changing at a furious rate, and so are technologies. In
            tandem, customer expectations to are changing rapidly.
          </p>
          <p className="paragraph-point">
            * Having long years of experience and being adept at various
            technologies, Amrutha Systems can meet any requirement of customers
            – old or new.
          </p>
        </div>
        <div className="mobile-image-container">
          <img
            src="https://uploads-ssl.webflow.com/6448bf6f0640203c982ca15f/6448bf6f0640207b472ca470_ENTERPRISE%20MOBILITY%20APPLICATIONS.webp"
            alt="mobile"
            className="picture"
          />
        </div>
      </div>
    </div>
  </div>
)
export default Mobile
